import { App,Flex,Image,Modal, Space, Table } from 'antd';
import React, { useState, useEffect } from 'react';
import { useBnsXiangMuBanBenListQuery, useBnsXiangMuBanBenDelMutation } from '../../store/BnsKeJiApi';
import ModalDel from '../../cpn/ModalDel';
import SketchEdit from '../sketch/SketchEdit';
import SketchAdd from '../sketch/SketchAdd';
import SketchAddCopy from '../sketch/SketchAddCopy';

function ModuleCheck(props) {
    const {message} = App.useApp()
    const [open, setOpen] = useState(false);    
    const [list, setList] = useState(); 
    const {data, isSuccess} = useBnsXiangMuBanBenListQuery({
        bxmbb_bxm_id:props.bxm_id,
        bxmbb_yh_id:props.yh_id,
        bxmbb_xq_id:props.bxmxq_id,
    },{refetchOnMountOrArgChange:1});    
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {bxmbb_id:key,bxmbb_name,bxm_id,bxmbb_ctime,bxmbb_cname,bxmbb_content,bxm_name,bxmbb_image} = item;
                    return item = {key,bxmbb_name,bxm_id,bxmbb_ctime,bxmbb_cname,bxmbb_content,bxm_name,bxmbb_image}
                })                
                let sorrArr = newArr.sort((a, b) => {
                    // 提取bxmbb_name的第一个数字
                    const getFirstNumber = (name) => {
                        if (!name) return 0;
                        const match = name.match(/\d+/);
                        return match ? parseInt(match[0]) : 0;
                    };
                    
                    const numA = getFirstNumber(a.bxmbb_name);
                    const numB = getFirstNumber(b.bxmbb_name);
                    
                    return numA - numB;
                });
                setList(sorrArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])  
    const columns = [
        {
            key: 'bxmbb_name',
            title: '名称',
            dataIndex: 'bxmbb_name',     
        }, 
        {
            key: 'bxmbb_image',
            title: '效果图',
            dataIndex: 'bxmbb_image',     
            render: (_,record) => <Image src={`/api/assets/images/application/${record.bxmbb_image}`} width={100} height={100}/>
        }, 
        {
            key: 'bxmbb_content',
            title: '备注',            
            dataIndex: 'bxmbb_content',           
        },
        {
            key: 'num',
            title: '编号',            
            dataIndex: 'key',           
        },
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) => {
                return <>{record.bxmbb_ctime + record.bxmbb_cname}</>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>  
                        <SketchEdit 
                            bxmbb_id={record.key} 
                            bxm_id={props.bxm_id} 
                            bxm_name={props.bxm_name}
                            eu_id={props.eu_id} 
                            eu_name={props.eu_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            bxmxq_id={props.bxmxq_id}
                            bxmxq_name={props.bxmxq_name}
                        />
                        <ModalDel onOk={() => {
                                                del({bxmbb_id:record.key}).then((res) => {
                                                    if (res.data.Status === 'success') {
                                                        message.success('删除成功！')                                                                              
                                                    }
                                                    if (res.data.Status === 'fail') {
                                                        message.error('删除失败！'+res.data.Message)
                                                    }
                                                })
                                            }} />  
                        <SketchAddCopy
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            bxm_id={props.bxm_id}
                            bxm_name={props.bxm_name}
                            eu_id={props.eu_id}
                            eu_name={props.eu_name}
                            bxmxq_name={props.bxmxq_name}
                            bxmxq_content={props.bxmxq_content}
                            bxmbb_name={record.bxmbb_name}
                            bxmbb_content={record.bxmbb_content}
                            bxmbb_image={record.bxmbb_image}
                            bxmbb_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]   
    //删除
    const [del] = useBnsXiangMuBanBenDelMutation()
    return (
        <>
            <a onClick={() => setOpen(true)}>{props.bxmxq_name}</a>
            <Modal
                open={open}
                title={props.bxm_name + '-' + props.yh_name + '-' + props.bxmxq_name + ' - 效果图列表'}
                onCancel={() => setOpen(false)}
                footer={false}
                width={1000}
                
            >
                <div dangerouslySetInnerHTML={{__html:props.bxmxq_content}}></div>
                <Flex justify='flex-end'>
                    <SketchAdd
                        bxm_id={props.bxm_id}
                        bxm_name={props.bxm_name}
                        yh_id={props.yh_id}
                        yh_name={props.yh_name}
                        eu_id={props.eu_id}
                        eu_name={props.eu_name}
                        bxmxq_id={props.bxmxq_id}
                        bxmxq_name={props.bxmxq_name}
                    />
                </Flex>
                <Table
                    columns={columns}
                    dataSource={list}
                    rowKey="key"                    
                    pagination={{
                        pageSize: 20,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/共 ${total} 条`,
                    }}
                />
            </Modal>
        </>
    );
}

export default ModuleCheck;
